import { render, staticRenderFns } from "./RSVPStatusBadge.vue?vue&type=template&id=1d4641b1"
import script from "./RSVPStatusBadge.vue?vue&type=script&lang=js"
export * from "./RSVPStatusBadge.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports